import { entriesApprovalsRoute } from '@web/containers/EntriesApprovals/helpers/routes';
import { leaveApprovalsRoute } from '@web/containers/LeaveApprovals/helpers/routes';
import { timeApprovalsRoute } from '@web/containers/TimeApprovals/helpers/routes';
import { useMatch, useNavigate } from 'react-router';

const useApprovalTabs = (path: string) => {
  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    if (tab === selectedTabId) return;
    void navigate(`${path}${tab}`);
  };

  const match = useMatch({ path: `${path}:tabSlug`, end: false });
  const selectedTabId = match?.params.tabSlug ?? 'todo';

  return {
    handleTabChange,
    selectedTabId,
  };
};

export const useTimeApprovalTabs = () => {
  return useApprovalTabs(`${timeApprovalsRoute}/`);
};

export const useEntriesApprovalTabs = () => {
  return useApprovalTabs(`${entriesApprovalsRoute}/`);
};

export const useLeaveApprovalTabs = () => {
  return useApprovalTabs(`${leaveApprovalsRoute}/`);
};
